var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
import { isAccepted, pollJob } from './jobs';
import { newProgressId } from './progress';
export function getGenerationCapabilities() {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get('/generation/capabilities');
    });
}
export function generateLevel(levelId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        // Each stage is a long job (the art stage can run past five minutes), and a
        // request held open that long did not survive production reverse proxies —
        // the author saw a failure while the server kept working. The server now
        // answers 202 immediately and runs the job detached; completion, the final
        // payload and the quotable error code all arrive through the progress
        // registry (see api/jobs.ts).
        const progressId = (_a = params.progressId) !== null && _a !== void 0 ? _a : newProgressId();
        const accepted = yield client.post(`/levels/${levelId}/generate`, Object.assign(Object.assign({}, params), { progressId }));
        if (!isAccepted(accepted)) {
            // An older server ran the job in-request and this is already the result.
            return accepted;
        }
        return pollJob(progressId, 'The generation status was lost — the server may have restarted. Check the level and try again.');
    });
}
